import { SelectOption } from '../../../../../../shared/interfaces';

export enum SAVED_QUOTES_STATES {
  QUOTE_SAVED = '1',
  EXPIRED_QUOTE = '2',
  OPERATION_OMITTED = '3',
  PROP_RECEIVED_CIA = '4',
  OPERATION_REMOVED_SUSP = '5',
  OPERATION_SUSP = '6',
}

export enum OPERATION_QUOTES_STATES {
  NEW_POLICE = '1',
  RENOVATION = '2',
  INCREASE_SUM = '3',
}

export const statesSavedQuotesFilter: Array<SelectOption> = [
  {
    label: 'COTIZACIÓN SALVADA',
    value: SAVED_QUOTES_STATES.QUOTE_SAVED,
  },
  {
    label: 'COTIZACIÓN VENCIDA',
    value: SAVED_QUOTES_STATES.EXPIRED_QUOTE,
  },
  {
    label: 'OP. EMITIDA',
    value: SAVED_QUOTES_STATES.OPERATION_OMITTED,
  },
  {
    label: 'PROP. RECIBIDA X CIA',
    value: SAVED_QUOTES_STATES.PROP_RECEIVED_CIA,
  },
  {
    label: 'OP. ELIM. DE SUSP.',
    value: SAVED_QUOTES_STATES.OPERATION_REMOVED_SUSP,
  },
  {
    label: 'EN PROC. EMISIÓN',
    value: SAVED_QUOTES_STATES.OPERATION_SUSP,
  },
];

export const operationSavedQuotesFilter: Array<SelectOption> = [
  {
    label: 'PÓLIZA NUEVA',
    value: OPERATION_QUOTES_STATES.NEW_POLICE,
  },
  {
    label: 'RENOVACIÓN',
    value: OPERATION_QUOTES_STATES.RENOVATION,
  },
  {
    label: 'AUMENTO DE SUMA',
    value: OPERATION_QUOTES_STATES.INCREASE_SUM,
  },
];
